import React from 'react';
import './About.css';
import trofeuIcon from '../../assets/trofeu.png';
import entregaRapidaIcon from '../../assets/entrega-rapida.png';
import parceriaIcon from '../../assets/parceria.png';

const About = () => {
  const values = [
    {
      icon: trofeuIcon,
      title: 'Qualidade Premium',
      description: 'Ingredientes frescos e de alta qualidade',
      isImage: true
    },
    {
      icon: entregaRapidaIcon,
      title: 'Entrega Rápida',
      description: 'Entregamos frescos sempre no prazo',
      isImage: true
    },
    {
      icon: '👨‍🍳',
      title: 'Expertise Culinária',
      description: 'Profissionais experientes e apaixonados',
      isImage: false
    },
    {
      icon: parceriaIcon,
      title: 'Parceria Confiável',
      description: 'Relacionamentos duradouros baseados na confiança',
      isImage: true
    }
  ];

  return (
    <section id="sobre-nos" className="about">
      <div className="about-container">
        {/* Seção Principal */}
        <div className="about-hero">
          <div className="about-content">
            <div className="about-text">
              <h2 className="about-title">QUEM SOMOS — PRIMEATS</h2>
              <p className="about-description">
                Elevamos o padrão da produção de hambúrgueres e cortes frigoríficos no Brasil. 
                Movidos por excelência em cada processo, garantimos produtos de qualidade superior.
              </p>
              <p className="about-description">
                Com rastreabilidade total e controle rigoroso, nossos produtos são reconhecidos pelo Selo SISBI. 
                Somos parceiros de longo prazo de hamburguerias, restaurantes e marcas que valorizam qualidade e confiança.
              </p>
              <p className="about-description about-description-highlight">
                Tecnologia e paixão a serviço do melhor hambúrguer.
              </p>
              
              {/* Destaque de Clientes */}
              <div className="about-stats">
                <div className="stat-divider"></div>
                <div className="stat-content">
                  <span className="stat-number">100+</span>
                  <span className="stat-text">clientes atendidos em todo o Brasil</span>
                </div>
                <div className="stat-divider"></div>
              </div>
            </div>
            <div className="about-image">
              <img 
                src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Nossa equipe trabalhando" 
              />
            </div>
          </div>
        </div>

        {/* Nossos Valores */}
        <div className="about-values">
          <div className="values-header">
            <h3 className="values-title">NOSSOS VALORES</h3>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  {value.isImage ? (
                    <img src={value.icon} alt={value.title} className="value-icon-image" />
                  ) : (
                    value.icon
                  )}
                </div>
                <h4 className="value-title">{value.title}</h4>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;